import productService from '../../services/product/product.js';

const actions = {
  toggleBurgerMenu({commit, state}) {
    if (state.isBurgerMenuOpen) {
      commit('hideBurgerMenu');
      commit('hideOverlay');
      document.body.classList.remove('modal-open')
    } else {
      commit('showBurgerMenu');
      commit('showOverlay');
      document.body.classList.add('modal-open')
    }
  },
  editProduct({commit}, data) {
    productService()
        .getProductEditData(data.type, data.requestData)
        .then((response) => commit('editProduct', {initialData: data, editedProduct: response}));
  },
  showModal({commit}, data) {
    commit('showModal', data);
  },
  hideModal({commit}, data) {
    commit('hideModal', data);
  },
  handleEditProduct({commit, dispatch, state}, data) {
    productService()
        .postNewProductData(data.url, data.data)
        .then((data) => {
          if (data) {
            if (data.cart) {
              commit('updateCart', data.cart);
            }
            dispatch('hideModal', {id: state.currentModalId});
          }
        });
  },
  editArticleInFlyout(context, data) {
    context.commit('editArticleInFlyout', data);
  },
  reduceCount(context, data) {
    context.commit('reduceCount', data);
  },
  addCount(context, data) {
    context.commit('addCount', data);
  }
};

export default actions;
